export default [
    {
        "id": "reminder",
        "html": require('./reminder/html').default,
        "css": require('./reminder/css').default,
        "cssTablet": require('./reminder/cssTablet').default,
        "cssMobile": require('./reminder/cssMobile').default,
        "scss": require('./reminder/scss').default,
        "scssTablet": require('./reminder/scssTablet').default,
        "scssMobile": require('./reminder/scssMobile').default
    }
]